import styled from 'styled-components';
import tw from 'twin.macro';

export const FieldContainer = styled.div<{
    isHidden?: boolean;
    isMarginBottomZero?: boolean;
    css?: any;
}>`
  ${tw`w-full relative`}
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  ${(props) => (props.isMarginBottomZero ? tw`mb-0` : tw`mb-4`)};

  -webkit-tap-highlight-color: transparent;
  input:-webkit-autofill {
    box-shadow: 0 0 0 50px white inset !important;
    -webkit-box-shadow: 0 0 0 50px white inset;
  }

  input:-webkit-autofill:focus {
    box-shadow: 0 0 0 50px white inset !important;
    -webkit-box-shadow: 0 0 0 50px white inset;
  }

  input:-webkit-autofill:disabled {
    box-shadow: 0 0 0 50px #f1f5f9 inset !important;
    -webkit-box-shadow: 0 0 0 50px #f1f5f9 inset;
  }

  ${(props) => props.css};
`;

export const IconContainer = styled.div<{ shouldShowLabel?: boolean }>`
  ${tw`absolute`};
  right: 8px;
  top: ${(props) => (props.shouldShowLabel ? '33px' : '13px')};
`;

